export function readDataset(key, transform) {
    if (transform === void 0) { transform = function (x) { return x; }; }
    return function (element) {
        var value = element.dataset[key];
        return value === undefined ? undefined : transform(value);
    };
}
